import classNames from "classnames";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  SELECT_BLOCK_ONCLICK,
  UPDATE_BLOCK_DATA,
  ADD_BLOCK_TO_PAGE,
  TOGGEL_POPUP,
  UPDATE_SITE_SETTINGS,
  SELECT_ELEMENT,
  RESTYLE_BLOCK,
} from "../../../constants/action.constants";
import { set, cloneDeep, find, findIndex } from "lodash";
import { twdClass } from "../../../constants/tailwind.constants";
import { getSheetInfo, getSheetColumns } from "../../../api/services";
import { toast } from "react-toastify";
import {Button} from "../../ui/button_ui";
import { ConnectionPanel } from "../connections/ConnectionPanel";
import { ConnectDataSourceVs_play, DynamicPageVs_play} from "../../content/visual_steps";
import * as JSONS_CARDS from "../../../jsons_restyle/parts/cards";
import { MapColumns } from "../blockguide/MapColumns";


const updateBlockDesign = ({
  table={},    
  styleProps={},
  stylePropsTab={},
  stylePropsMob={},
  headings=[],
  cardLocations=[], 
  cardElements=[], 
  cardConfig={},
  overlay={}
}, blockInfo) => {

  let blk = cloneDeep(blockInfo);
  //blk = set(blk, key, value);
  blk.styleProps=styleProps
  blk.stylePropsTab=stylePropsTab
  blk.stylePropsMob=stylePropsMob

  blk.headings=headings

  blk.table=table
  blk.cardLocations=cardLocations
  blk.cardElements=cardElements
  blk.cardConfig=cardConfig

  blk.overlay=overlay
  
  return blk
};


const BlockGuide = ({blockInfo={}, metaDataId='', bkt}) => {
  const dispatch = useDispatch();
  const {
    openRightPanel,
    selectedBlock={},
    pageInfo: { blocks },
    projectData: { connections, project_id },
  } = useSelector((state) => state.studioDetails); 
  //console.log("configs", configs)
  const {table={}, configs={}, connection={}, cardElements=[]} = blockInfo
  let {useDummyDataSource=false} = configs 
  if(!useDummyDataSource)  return <></>  
  if(bkt!=='CARDS') return <></>   
  //console.log("blockInfo", blockInfo)

  const replaceBlock = (blk) => { 
    const mBlocks = blocks.map((item) => {
      if (item.metaDataId === blk.metaDataId) {
        return { ...blk };
      }
      return item;
    });

    dispatch({
      type: UPDATE_BLOCK_DATA,
      data: mBlocks,
    });
  }
  const updateElementValue = (key, value) => {
    let blk = cloneDeep(blockInfo);
    blk = set(blk, key, value);
    replaceBlock(blk)
  };

  const openConnections = () => {
    dispatch({
      type: TOGGEL_POPUP,
      data: {
        showPopup: true,
        title: (<div className={twdClass('flex items-center')}><div  className={twdClass('mr-12')}>Connections</div><ConnectDataSourceVs_play/></div>),
        component: <ConnectionPanel {...{initPanel:"addedit"}}/>,
      },
    });
  };

  const chooseConnection = () => {
    dispatch({
      type: SELECT_BLOCK_ONCLICK,
      data: blockInfo,
    });
  };
  
  const designs = [
    {
      label:'Design 1', image:'',
      metaData:JSONS_CARDS.CARD_01
    },
    {
      label:'Design 2', image:'',
      metaData:JSONS_CARDS.CARD_02
    },
    {
      label:'Design 3', image:'',
      metaData:JSONS_CARDS.CARD_03
    }
  ]

  const selectDesign = (item) => {
    let cards=[
      {
        "type": "text",
        "id": 1746614359749,
        "elIndex": 0,
        "text": "fasty :  [[role]]",
        "location": "A",
        "styleProps": {
          "color": "#ffa611"
        },
        "params": [
          {
            "value": "role",
            "label": "role"
          }
        ]
      }
    ]

    let updatedBlockDesign= updateBlockDesign(item.metaData, blockInfo)
    replaceBlock(updatedBlockDesign);
    
  }


  
  const openRP = openRightPanel  ? 'check.svg' : 'check-disabled.svg'
  const ConnectionSelected = configs.connection.connectionId ? 'check.svg' : 'check-disabled.svg'
  const SheetSelected = configs.connection.sheetName || configs.connection.connectionTable ? 'check.svg' : 'check-disabled.svg'
  const ConnectionSelectedSt =  configs.connection.connectionId ? true : false
  const SheetSelectedSt = configs.connection.sheetName || configs.connection.connectionTable ? true : false
  // console.log("blockInfo", configs.connection)
 // console.log("selectedBlock", selectedBlock)

  const step1UI=(
    <div className={twdClass("flex flex-row  w-full  mx-auto")} style={{maxWidth:"1000px"}}>
      <div className={twdClass("w-6/12")}>
        <div className={twdClass("text-xl font-semibold mb-4")}>Create a new data source connection</div>
        <ol className={twdClass("list-inside list-decimal")}>
          <li>Click "Create new data source connection"</li>
          <li>Select your data source</li>
          <Button
            type="default"  color="black" className={"inline-block mt-8"}   
            onClick={openConnections}
          >
            Create connection
          </Button>
        </ol>
      </div>
      <div className={twdClass("w-6/12 ")}>
        <div className={twdClass("text-xl font-semibold mb-4")}> Select an existing data source connection</div>
        <ol className={twdClass("list-outside flex flex-col gap-2 ")}>          
          <li className={twdClass("flex items-center")}><img className={twdClass(`${ConnectionSelectedSt ? 'bg-green-200' : 'bg-gray-100'} p-2 rounded-full mr-2 inline-block`)} src={`/assets/images/${ConnectionSelected}`}/> Choose the existing data source connection </li>
          <li className={twdClass("flex items-center")}><img className={twdClass(`${SheetSelectedSt ? 'bg-green-200' : 'bg-gray-100'} p-2 rounded-full mr-2 inline-block`)} src={`/assets/images/${SheetSelected}`}/> Select the Sheet Name from your data source</li>
        </ol>
        {((selectedBlock && selectedBlock.metaDataId != metaDataId )|| !openRightPanel)  && <Button
          type="default"  color="black" className={"inline-block mt-8"}   
          onClick={chooseConnection}
        >
          Configure Data Source
        </Button>}
        <img className={twdClass("mt-8")} src={'/assets/images/ui/PropertyPanel.png'}/>
      </div>
    </div>
  )
  const step3UI=(
    <div className={twdClass("w-full  mx-auto ")} style={{maxWidth:"1000px"}}>
      <div className={twdClass("flex flex-col items-center justify-center ")}>  
        <div className={twdClass("text-xl font-semibold mb-4")}>Map Variables</div>  
        <div className={twdClass("mb-8")}>Map variables in the card design to the corresponding column names in your data source.</div>   
        <MapColumns {...{blockInfo, replaceBlock, connection:configs.connection}}/>
      </div>      
    </div>
  )

  return (
    <>
      {(!configs.connection.sheetName && !configs.connection.connectionTable) && 
      <div className={twdClass("pb-12 px-12 z-10 pt-1 relative")} style={{backgroundColor:blockInfo.styleProps['background-color']  ? blockInfo.styleProps['background-color']: '#ffaaaa'}}>
        <div className={twdClass("relative pt-1")} >
          <div className={twdClass("relative z-10 w-0 h-0 mx-auto")} style={{marginTop:'-36px', borderLeft: '20px solid transparent', borderRight: '20px solid transparent', borderBottom: '20px solid #fff'}}></div>
        </div>
        <div className={twdClass("container relative -mt-4 mx-auto py-12 px-12 bg-white rounded-2xl shadow-xl")}>
          
          <div>
            <div className={twdClass("flex flex-col items-center justify-center mx-auto text-center mb-12")} style={{maxWidth:"600px"}}>
              <div className={twdClass("text-3xl font-semibold mb-2")}>Configure Dynamic Cards </div>
              <div>Link your Google Sheet or Supabaase to our platform, enabling seamless data integration and dynamic card generation.</div>         
            </div>
            {step1UI}           
            {/*((configs.connection.sheetName || configs.connection.connectionTable) && (table.columns.length >0 || cardElements.length > 0)) ? step3UI :<></>*/}
          </div>              
        </div>
      </div>
      }
    </>
  )
}
export {BlockGuide}